import styled from 'styled-components';

/** Плавное развёртывание калькулятора в потоке (как CalendarExpandPanel в модалках).
 * При overflow:hidden родитель режет box-shadow потомка прямым углом — при открытии даём место под тень. */
export const CalculatorExpandPanel = styled.div`
  width: 100%;
  max-height: ${p => (p.$open ? '420px' : '0')};
  overflow: ${p => (p.$open ? 'visible' : 'hidden')};
  opacity: ${p => (p.$open ? 1 : 0)};
  transition:
    max-height 0.45s cubic-bezier(0.33, 1, 0.68, 1),
    opacity 0.28s ease,
    margin-top 0.35s ease,
    padding-bottom 0.35s ease;
  pointer-events: ${p => (p.$open ? 'auto' : 'none')};
  margin-top: ${p => (p.$open ? '10px' : '0')};
  padding-bottom: ${p => (p.$open ? '18px' : '0')};
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
  align-items: center;
`;
export const DisplayS = styled.div`
  display: flex;
  margin-bottom: 9px;
  align-items: center;
  justify-content: space-around;
`;
export const ButtonCur = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  line-height: 0;
  border: 1px solid ${p => p.theme.colors.main.grayLight};
  background-color: ${p => p.theme.colors.main.white};
  border-radius: 50%;
  cursor: pointer;

  svg {
    display: block;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    color: ${p => p.theme.colors.main.orangeMain};
    fill: currentColor;
  }
`;
export const Input = styled.input`
  color: ${p => p.theme.colors.main.orangeMain};
  border: 0px;
  font-size: 16px;
  letter-spacing: 1.5px;
  background: ${p => p.theme.colors.main.orangeLight};
  border-radius: 16px;
  border: none;
  margin-left: 8px;
  width: 100%;
  height: 40px;
  padding-left: 16px;
  ::placeholder {
    color: ${p => p.theme.colors.text.gray};
  }
`;
export const Button = styled.button`
  width: 40px;
  height: 28px;

  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  cursor: pointer;
  border: 1px solid ${p => p.theme.colors.main.orangeLight};
  border-radius: 16px;
  background: none;
  color: ${p => p.theme.colors.main.orangeMain};
  margin: 12px;
  user-select: none;

  &:hover {
    background-color: ${p => p.theme.colors.main.orangeMain};
    color: #ffffff;
    transition: background-color 0.3s ease;
    border-radius: 16px;
  }
  &:touched {
    background-color: ${p => p.theme.colors.main.orangeMain};
    color: #ffffff;
    transition: background-color 0.3s ease;
    border-radius: 16px;
  }
`;
export const BtnClose = styled.button`
  width: 116px;
  height: 44px;
  border: 1px solid ${p => p.theme.colors.main.orangeMain};
  border-radius: 16px;
  background-color: ${p => p.theme.colors.main.orangeMain};
  color: #ffffff;
`;
export const BtnCloseWrap = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-content: center;
`;
export const Wrap = styled.div`
  position: ${p => (p.$embedInFlow ? 'relative' : 'absolute')};
  z-index: ${p => (p.$embedInFlow ? 'auto' : 4)};
  top: ${p => (p.$embedInFlow ? 'auto' : p.indentation)};
  right: ${p => (p.$embedInFlow ? 'auto' : '14px')};
  left: ${p => (p.$embedInFlow ? 'auto' : 'auto')};
  width: ${p => (p.$embedInFlow ? '100%' : 'calc(100% - 48px)')};
  box-sizing: border-box;
  background-color: ${p => p.theme.colors.main.white};
  border: 1px solid ${p => p.theme.colors.main.grayLight};
  isolation: isolate;
  border-radius: 30px;
  padding: 4px 8px;
  /* Тень только снаружи рамки со скруглением родителя; overflow:auto у модалки не даёт клип-прямугольника на тени дочернего из overflow:hidden панели */
  box-shadow: ${p => p.theme.modal.elevatedPopover};
`;
